import React from 'react';
import { Row, Col, Button, Affix } from 'antd';
import AddAdministratorFields from './AddAdministratorFields';
import { IconArrowLeft } from '../../../../../common/ui/icons';

const AddAdministratorForm = ({ form, name, validateField, ...rest }) => {
  const handleFormSubmit = () => {
    rest.handleMediumFormSubmit(name);
  };
  return (
    <div id="addAdministrator" className="basicForm">
      <Row type="flex" justify="space-between" gutter={16}>
        <Col span={18}>
          <div className="formContainer">
            <AddAdministratorFields form={form} validateField={validateField}/>
          </div>
        </Col>
        <Col span={6}>
          <div className="sidebarContainer">
            <Affix
              offsetTop={18}
              target={() => document.getElementById('mainSheet')}
            >
              <React.Fragment>
                <div className="button">
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={handleFormSubmit}
                  >
                    Далее
                  </Button>
                  <Button style={{ marginTop: 20 }} onClick={() => rest.prev()}>
                    <IconArrowLeft />
                    Назад
                  </Button>
                </div>
              </React.Fragment>
            </Affix>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AddAdministratorForm;
